<template>
  <div class="sponsor-tile" :href="data.link">
    <a class="sponsor-link" :href="data.link" target="_blank">
      <img :src="logoSrc" :alt="data.name" class="sponsor-logo" loading="lazy" decoding="async" />
      <p class="sponsor-name" > <b>{{ data.name }}</b></p>
      <p class="sponsor-tier">{{ data.tier }}</p>
    </a>
  </div>
</template>

<script>
export default {
  name: "SponsorTile",
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    logoSrc() {
      if (!this.data.logo) return '';
      const logo = this.data.logo.trim();
      if (/^(https?:|\/|data:)/i.test(logo)) {
        return logo;
      }
      if (logo.startsWith('sponsors/')) {
        return `/${logo}`;
      }
      return `/sponsors/${logo}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.sponsor-tile {
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  
  .sponsor-link {
    // align-items: center;
    text-decoration: none;
    color: var(--dark);
    
    .sponsor-logo {
      max-width: 20em;
      max-height: 7em;
      margin-bottom: 0.5rem;
      transition: transform var(--transition-fast);
    }
      
    .sponsor-name {
      margin-bottom: 0;
      max-width: 20em;
      align-items: center;
    }
    
    .sponsor-tier {
      text-decoration: none;
      margin-top: .3em;
    }
    
    &:hover {
      cursor: pointer;
      .sponsor-logo {
        transform: scale(1.05);
      }
      .sponsor-name{
        text-decoration: underline;
      }    
    }
  }
}

@media screen and (max-width: 768px) {
  .sponsor-tile {
    margin-top: 0.5rem;
    width: 100%;

    .sponsor-link {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      .sponsor-logo {
        max-width: clamp(95px, 35vw, 140px);
        max-height: 3.25rem;
        object-fit: contain;
        margin-bottom: 0.3rem;
      }

      .sponsor-name {
        font-size: 0.82rem;
        line-height: 1.25;
        max-width: 140px;
        margin: 0;
      }

      .sponsor-tier {
        font-size: 0.72rem;
        margin-top: 0.15rem;
      }
    }
  }
}
</style>